import { Controller } from "remult";

@Controller("sub-team-methods")
export class SubTeamMethods {}
